import { render, staticRenderFns } from "./AimingFor.vue?vue&type=template&id=348fed26&"
import script from "./AimingFor.vue?vue&type=script&lang=ts&"
export * from "./AimingFor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/circleci/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('348fed26')) {
      api.createRecord('348fed26', component.options)
    } else {
      api.reload('348fed26', component.options)
    }
    module.hot.accept("./AimingFor.vue?vue&type=template&id=348fed26&", function () {
      api.rerender('348fed26', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/data-entry/views/ward/discharge/AimingFor.vue"
export default component.exports